





















import { Vue, Component } from "vue-property-decorator";
import store from "./store";
import Axios from "axios";

@Component
export default class App extends Vue {
  logged = false;
  passwd = "";

  login() {
    Axios.get("https://api.clubdobalanco.com/v1/hold", {
      headers: { Authorization: `Bearer ${this.passwd}` }
    })
      .then(() => {
        this.logged = true;
        store.commit("setPasswd", this.passwd);
      })
      .catch(e =>
        this.$notify.error({ title: "Erro", message: "Senha Incorreta" })
      );
  }
}
